/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSuggestedAnswerSource
 */
export interface ControlSuggestedAnswerSource {
    /**
     * 
     * @type {string}
     * @memberof ControlSuggestedAnswerSource
     */
    form_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSuggestedAnswerSource
     */
    question_id: string;
}

/**
 * Check if a given object implements the ControlSuggestedAnswerSource interface.
 */
export function instanceOfControlSuggestedAnswerSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_id" in value;
    isInstance = isInstance && "question_id" in value;

    return isInstance;
}

export function ControlSuggestedAnswerSourceFromJSON(json: any): ControlSuggestedAnswerSource {
    return ControlSuggestedAnswerSourceFromJSONTyped(json, false);
}

export function ControlSuggestedAnswerSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSuggestedAnswerSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_id': json['form_id'],
        'question_id': json['question_id'],
    };
}

export function ControlSuggestedAnswerSourceToJSON(value?: ControlSuggestedAnswerSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_id': value.form_id,
        'question_id': value.question_id,
    };
}

